export const BOARD = [
  {
    name: "Manvinder Randhawa",
    title: "Founder , CEO",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_5336d481-0648-4663-98bb-dc81e14a84b6/artifacts/qo4lcuqg_Manvinder1310202320853_Square_WEB.jpg",
    bio: "Manvinder is the visionary founder of IBY Vision Foundation, dedicated to empowering young people from culturally diverse and disadvantaged backgrounds through mentorship and opportunity. With 30+ years of experience in technology and leadership, she drives systemic change by advancing education, equity, resilience, and youth empowerment.",
    group: "leadership",
  },
  {
    name: "Neil Sequeira",
    title: "Board Member, Director – Strategy",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_5336d481-0648-4663-98bb-dc81e14a84b6/artifacts/xps0d6n1_Neil-image.jpeg",
    bio: "Neil is a Chartered Accountant with nearly 30 years of experience across strategy, operations, startups, and large businesses, known for solving complex problems and developing people. He is a passionate mentor, community volunteer, musician, speaker, and writer who helps others build confidence, skills, and purpose.",
    group: "leadership",
  },
  {
    name: "Paul Anscombe",
    title: "Director, Community and industry Partnerships",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_5336d481-0648-4663-98bb-dc81e14a84b6/artifacts/sbgd4t1b_Paul-1.jpg",
    bio: "Paul is a senior executive with 25+ years of global leadership experience across Australia, Asia-Pacific, New Zealand, and the UK. At IBY Vision Foundation, he leads partnerships and sponsorships, creating career pathways and stronger collaboration to empower culturally diverse young people.",
    group: "leadership",
  },
  {
    name: "Paullomi Thomas",
    title: "Director, Strategy and Programs",
    img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_5336d481-0648-4663-98bb-dc81e14a84b6/artifacts/9d0ibiw9_Paullomi%20Thomas.webp",
    bio: "Paullomi Thomas is a strategic leader with 20+ years of cross-sector experience, specialising in strategy, transformation, governance, and executive decision-making. She is passionate about equity, inclusion, youth, and education, bringing a strong commitment to creating fairer systems and opportunities for all.",
    group: "leadership",
  },
  {
    name: "Vanessa Mitchell",
    title: "Director, Communications & Marketing",
    img: "/images/vanessa-mitchell.png",
    bio: "Vanessa has 25+ years of experience in communications, specialising in technology, corporate communications, content strategy, PR, and journalism. She is passionate about empowering women and girls through confidence, mentorship, and encouragement to pursue their full potential.",
    group: "leadership",
  },
  {
    name: "Michelle Rowland",
    title: "Director, Community Engagement & Partnerships",
    img: "/images/michelle-rowland.png",
    bio: "Michelle Rowland is a community leader with 15+ years of experience in social impact and community development. She is passionate about empowering disadvantaged youth through mentoring and career opportunities. At IBY Vision Foundation, she leads community engagement and partnerships to expand its impact.",
    group: "leadership",
  },
];

export const TEAM = [
  {
    name: "Angela Holbery",
    title: "Director, Risk, Governance & Compliance",
    img: "/images/angela-holbery.png",
    bio: "Angela Holbery is a purpose-driven technology leader with 30+ years of experience in CX, AI, automation, outsourcing, and digital transformation. At IBY Vision Foundation, she leads Risk, Governance and Compliance, supporting strong organisational growth. She also mentors young people, particularly women, to explore and thrive in STEM careers.",
  },
  {
    name: "Juhi Jain",
    title: "Technology & Data Strategy",
    img: "/images/juhi-jain.png",
    bio: "Juhi is a solution-oriented technology professional passionate about building practical, human-centered systems that create social impact. She combines data, design, and technology to strengthen communities and support meaningful outcomes. At IBY Vision Foundation, she supports data strategy, analytics, and scalable technology solutions. As a mentor and advocate for lifelong learning, she champions inclusive leadership and helping others grow.",
  },
  {
    name: "Zita Ann Raja",
    title: "Service Design & Program Design",
    img: "/images/zita-ann-raja.png",
    bio: "Zita Ann Raja is a creative, systems-oriented designer passionate about empowering young people through human-centered design. With expertise in service design and systems thinking, she creates meaningful programs that inspire students to explore their strengths and future possibilities. At IBY Vision Foundation, she designs activities that help young people connect their interests and values with real-world impact. Her approach is grounded in empathy, creativity, and inclusive collaboration.",
  },
  {
    name: "Gowri Penkar",
    title: "Design & Leadership",
    img: "/images/gowri-penkar.png",
    bio: "Gowri Penkar is an experienced design leader with 25+ years of global expertise in service design, strategic design, and research. She is passionate about inclusive leadership and mentoring, particularly supporting culturally diverse communities to thrive in Australia. At IBY Vision Foundation, she contributes expertise in design, systems thinking, leadership development, and organisational performance. Her work is driven by a commitment to elevating diverse voices and creating more inclusive systems.",
  },
  {
    name: "Ted Chang",
    title: "Finance & Governance",
    img: "/images/ted-chang.png",
    bio: "Ted Chang is a finance professional with 15+ years of experience in financial reporting, budgeting, grants, and process improvement. He is passionate about helping purpose-driven organisations maintain strong financial practices and achieve sustainable growth. Ted brings a practical, collaborative approach to supporting not-for-profits with governance, compliance, and funding obligations.",
  },
];

export const PROGRAMS = [
  {
    id: "inspire",
    num: "01",
    name: "IBY Inspire",
    stage: "Years 9–11",
    tagline: "See what's possible.",
    color: "#FFB323",
    who: "Students in Years 9–11 beginning to think about who they are and where they're headed.",
    delivers:
      "Self-awareness workshops, career exploration sessions, and encounters with relatable role models from culturally diverse backgrounds who've walked similar paths.",
    format: "Face-to-face group sessions, delivered in schools and community spaces.",
    outcomes: [
      "Students can name their strengths and interests",
      "Exposure to careers they never knew existed",
      "A role model who looks and sounds like them",
    ],
    img: "https://images.unsplash.com/photo-1529390079861-591de354faf5?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "evolve",
    num: "02",
    name: "IBY Evolve",
    stage: "Senior Students",
    tagline: "Build the bridge.",
    color: "#FF5A36",
    who: "Senior secondary students ready to turn interest into direction.",
    delivers:
      "Structured 1:1 mentoring with an expert mentor matched to the student's aspirations, culture and personality — goal-setting, study pathways, subject choices and confidence building.",
    format: "Tailored, in-person 1:1 mentoring across the school year.",
    outcomes: [
      "A clear, personal career pathway plan",
      "A trusted mentor in their corner",
      "Confidence to back their own ambition",
    ],
    img: "https://images.unsplash.com/photo-1581404917879-53e19259fdda?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "achieve",
    num: "03",
    name: "IBY Achieve",
    stage: "Post-School",
    tagline: "Step confidently in.",
    color: "#0B132B",
    who: "School leavers transitioning into work, training or further study.",
    delivers:
      "Job readiness coaching, interview and résumé preparation, work-based learning placements, and warm introductions into real workplaces through IBY's partner network.",
    format: "In-person coaching, workplace visits and supported placements.",
    outcomes: [
      "Real work experience with real employers",
      "Interview-ready skills and professional networks",
      "A confident first step into a fulfilling career",
    ],
    img: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1200&auto=format&fit=crop",
  },
];

export const STATS = [
  { value: "926", label: "Students reached", note: "through workshops, mentoring and career events" },
  { value: "85", label: "Industry mentors engaged", note: "" },
  { value: "42", label: "Workshops and mentoring sessions", note: "delivered" },
  { value: "5", label: "Partner schools & community organisations", note: "" },
  { value: "6", label: "Industry partners", note: "supporting student exposure" },
  { value: "110", label: "Student contact hours", note: "" },
];

export const VALUES = [
  { name: "Drive", icon: "Rocket", desc: "We move with purpose — real outcomes, not empty positivity." },
  { name: "Inclusivity", icon: "Users", desc: "Every culture, every language, every story belongs here." },
  { name: "Resilience", icon: "Mountain", desc: "We back young people through setbacks, not just wins." },
  { name: "Dependability", icon: "ShieldCheck", desc: "When we say we'll show up, we show up. Every time." },
  { name: "Understanding", icon: "HeartHandshake", desc: "We listen first — identity and lived experience lead the way." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Before IBY, I couldn't picture anyone like me in a corporate office. My mentor showed me it wasn't just possible — it was already happening. Now I'm the one showing my little sister.",
    name: "Amara",
    role: "Student, IBY Evolve",
    type: "Students",
    img: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "The advice I got at school was 'work hard and you'll be fine.' IBY was the first place that actually explained how careers work — networks, pathways, interviews. Real stuff.",
    name: "Danyal",
    role: "Student, IBY Achieve",
    type: "Students",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "I walked into my first work placement terrified. My IBY mentor had prepped me for everything — even what to wear. By week two, I belonged there.",
    name: "Thuy",
    role: "Student, IBY Achieve",
    type: "Students",
    img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "Mentoring with IBY is the most meaningful hour of my week. These students don't lack talent — they lack access. Watching that gap close in real time is extraordinary.",
    name: "Sarah K.",
    role: "Mentor, Engineering",
    type: "Mentors",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "I give the advice I wish someone had given me at seventeen. IBY makes it easy — they match you well, train you properly, and the students bring everything.",
    name: "James O.",
    role: "Mentor, Finance",
    type: "Mentors",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "We've run many programs over the years. IBY is different — it's culturally grounded, genuinely tailored, and our students light up when the mentors walk in.",
    name: "[Principal Name]",
    role: "Principal, Partner School",
    type: "Schools",
    img: "https://images.unsplash.com/photo-1544717305-2782549b5136?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "The engagement from our culturally diverse students in IBY sessions is unlike anything we've seen. They finally see themselves in the future being described.",
    name: "[Careers Advisor Name]",
    role: "Careers Advisor, Partner School",
    type: "Schools",
    img: "https://images.unsplash.com/photo-1581404917879-53e19259fdda?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "Partnering with IBY isn't CSR box-ticking. It's a pipeline of driven, resilient young talent we would never have met otherwise. Our teams are better for it.",
    name: "[Partner Name]",
    role: "Head of People, Corporate Partner",
    type: "Partners",
    img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=400&auto=format&fit=crop",
  },
  {
    quote:
      "IBY delivers exactly what they promise — measurable outcomes, transparent reporting, and stories that move our whole organisation.",
    name: "[Sponsor Name]",
    role: "Community Investment Lead",
    type: "Partners",
    img: "https://images.unsplash.com/photo-1573496799652-408c2ac9fe98?q=80&w=400&auto=format&fit=crop",
  },
];

export const PARTNERS = [
  {
    name: "Atmus",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_youth-futures-2/artifacts/3guh9p32_Atmus_Color_Logo_Horizontal_1.jpg",
  },
  {
    name: "Cummins",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_youth-futures-2/artifacts/ca985qiz_Cummins-Logo.wine.webp",
  },
];

export const BLOGS = [
  {
    slug: "amaras-story-a-seat-at-the-table",
    title: "\u201CI didn't know anyone in that industry\u201D — Amara's road to a seat at the table",
    category: "Student Stories",
    readTime: "5 min read",
    date: "May 2026",
    excerpt:
      "Amara's parents arrived with two suitcases and no professional networks. Here's how one mentor match changed the trajectory of an entire family.",
    img: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=1200&auto=format&fit=crop",
    author: { name: "IBY Stories Team", role: "Student Stories", img: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=200&auto=format&fit=crop" },
    body: [
      { type: "p", text: "When Amara started Year 11, her careers plan was a single line: \u201Csomething in an office, maybe.\u201D Not because she lacked ambition — she was top of her class in maths — but because ambition needs a picture, and no one had ever shown her one." },
      { type: "p", text: "Her parents arrived in Australia with two suitcases, three children and no professional networks. \u201CMy mum cleaned offices in the buildings I now dream about working in,\u201D Amara says. \u201CShe could tell me to work hard. She couldn't tell me what a graduate program was, because no one had ever told her.\u201D" },
      { type: "quote", text: "Ambition needs a picture. No one had ever shown her one." },
      { type: "h2", text: "The match that changed everything" },
      { type: "p", text: "Through IBY Evolve, Amara was matched with Priya — a data analyst who grew up ten minutes from Amara's school, speaking the same language at home. Their first session wasn't about résumés. It was about identity: what it feels like to be the translator for your parents, the first in the family to finish school, the one carrying everyone's hopes." },
      { type: "p", text: "\u201CPriya didn't hand me a brochure,\u201D Amara laughs. \u201CShe showed me her actual work. Her actual pay slip, honestly. She made it real. And then she said the sentence I'll never forget: 'There is nothing in this building you can't do.'\u201D" },
      { type: "h2", text: "From dreaming to doing" },
      { type: "p", text: "Over twelve months of face-to-face mentoring, Amara built a subject plan aligned to a data science pathway, visited Priya's workplace twice, and practised interviews until the nerves became energy. Through IBY Achieve, she's now completing a work-based learning placement — in the same precinct where her mother once cleaned offices at night." },
      { type: "quote", text: "\u201CThey don't just dream about careers — they see them, access them, and step confidently into them.\u201D That's not our tagline. That's Amara's life." },
      { type: "p", text: "Amara's little sister just enrolled in IBY Inspire. The picture, once seen, gets passed on." },
    ],
  },
  {
    slug: "why-i-mentor-the-advice-i-never-got",
    title: "Why I mentor: giving the advice I never got at seventeen",
    category: "Mentor Spotlights",
    readTime: "4 min read",
    date: "April 2026",
    excerpt:
      "James spent his first decade in finance feeling like an outsider who'd snuck in. Now he spends Thursday afternoons making sure the next generation walks in the front door.",
    img: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1200&auto=format&fit=crop",
    author: { name: "IBY Stories Team", role: "Mentor Spotlights", img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=200&auto=format&fit=crop" },
    body: [
      { type: "p", text: "James O. remembers exactly one piece of careers advice from school: \u201Cpick something safe.\u201D As the son of migrants who worked double shifts, safe felt like the only option on the table. He got into finance almost by accident — a chance conversation, a lucky break, a decade of feeling like he'd snuck in through a side door." },
      { type: "quote", text: "\u201CI wasn't less capable than my colleagues. I just started the race three suburbs back from the starting line.\u201D" },
      { type: "h2", text: "The Thursday hour" },
      { type: "p", text: "Every Thursday afternoon, James sits down face-to-face with Danyal, a senior student in the IBY Evolve program. They've covered subject selection, scholarship applications, and how compound interest works — but also the unspoken things: how to walk into a room you feel you don't belong in, how to introduce yourself, how to ask for help without shame." },
      { type: "p", text: "\u201CIBY's matching is the secret,\u201D James says. \u201CDanyal and I get each other. When he tells me his parents don't understand what a cadetship is, I don't just sympathise — I lived it. That shared ground means we skip months of small talk and get straight to what matters.\u201D" },
      { type: "h2", text: "What mentors actually get back" },
      { type: "p", text: "Ask James what he gains and the answer is immediate: \u201CPerspective. Energy. The reminder of why any of this matters. Danyal works harder than anyone I know. Watching doors open for him — doors I had to shoulder through — is the best hour of my week.\u201D" },
      { type: "p", text: "IBY mentors receive full training, careful matching, and ongoing support. You bring your experience; we bring the structure. One hour a week. A trajectory changed for good." },
    ],
  },
  {
    slug: "what-employers-actually-look-for",
    title: "What employers actually look for — and how culturally diverse students can show it",
    category: "Industry Insights",
    readTime: "6 min read",
    date: "March 2026",
    excerpt:
      "Multilingual, resilient, adaptable — culturally diverse students already have the qualities employers say they can't find. The gap isn't capability. It's translation.",
    img: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200&auto=format&fit=crop",
    author: { name: "IBY Programs Team", role: "Industry Insights", img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop" },
    body: [
      { type: "p", text: "Ask any hiring manager what they struggle to find, and the same words come back: adaptability, resilience, communication across difference, drive. Now consider a student who moved countries, learned a new language, navigated two cultures daily, and translated official documents for their parents since age ten." },
      { type: "quote", text: "The gap isn't capability. It's translation — helping students name what they already carry." },
      { type: "h2", text: "The hidden résumé" },
      { type: "p", text: "In our IBY Achieve workshops, we run an exercise called \u201Cthe hidden résumé.\u201D Students list things they've never considered achievements: interpreting at a parent's medical appointment, managing the family's paperwork, working weekend shifts while studying, mediating between generations at home. Then we translate — into stakeholder communication, administration, time management, negotiation." },
      { type: "p", text: "The room changes. Students who arrived saying \u201CI have no experience\u201D leave with a page of evidence that they've been operating at a professional level for years — just unpaid, and unnamed." },
      { type: "h2", text: "What employers can do" },
      { type: "p", text: "For our corporate partners, the insight cuts the other way. Structured interviews that ask for real problem-solving stories — rather than polished corporate vocabulary — surface this talent immediately. Work-based learning placements do it even better: two weeks of seeing a student operate beats any interview." },
      { type: "p", text: "The organisations partnering with IBY aren't doing charity. They're getting first access to a talent pool the market consistently undervalues. That's not a feel-good line — it's a competitive advantage." },
    ],
  },
  {
    slug: "iby-achieve-expands-work-based-learning",
    title: "Program update: IBY Achieve expands work-based learning placements",
    category: "Program Updates",
    readTime: "3 min read",
    date: "February 2026",
    excerpt:
      "More partner workplaces, more placements, more first days. Here's what's growing in IBY Achieve this year — and how your organisation can open a door.",
    img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1200&auto=format&fit=crop",
    author: { name: "IBY Programs Team", role: "Program Updates", img: "https://images.unsplash.com/photo-1581404917879-53e19259fdda?q=80&w=200&auto=format&fit=crop" },
    body: [
      { type: "p", text: "There's a moment we never get tired of: a student's first day inside a real workplace. The lanyard. The desk. The quiet realisation that this world — the one that felt locked — has a door with their name on it." },
      { type: "p", text: "This year, IBY Achieve is expanding its work-based learning program with new placement partners across [industries — to be confirmed], creating more of those first days than ever before." },
      { type: "h2", text: "What's new" },
      { type: "p", text: "Placements now include structured week-one onboarding designed with our partners, a workplace buddy alongside the student's IBY mentor, and a final-week showcase where students present what they've built or learned to the host team. Every placement remains face-to-face, tailored and supported — that's non-negotiable." },
      { type: "quote", text: "Real access — not just inspiration. A placement is access in its purest form." },
      { type: "h2", text: "Open a door" },
      { type: "p", text: "If your organisation can host a placement — even one student, even one fortnight — you can change a trajectory. IBY handles preparation, matching, supervision support and feedback. You provide the door. Get in touch through our contact page and choose \u201CPartner\u201D — we'll take it from there." },
    ],
  },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Board & Team", path: "/team" },
  { label: "Partners", path: "/partners" },
  { label: "Blogs", path: "/blogs" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];
